// MODIFICA DA COSÌ:
// const API_BASE_URL = 'http://localhost:3006/api';

// A COSÌ (Valido sia in locale con il proxy di Vite, sia online su gledger.net):
const API_BASE_URL = '/api';

class TransazioniService {
  // --------------------------------Get tutte le transazioni (Giornale)
  async getTransazioni(userId) {
    try {
      const response = await fetch(`${API_BASE_URL}/transazioni?user_id=${userId}`);
      if (!response.ok) throw new Error('Errore caricamento transazioni');
      return await response.json();
    } catch (error) {
      console.error('Errore caricamento transazioni:', error);
      throw error;
    }
  }

  // -------------------------------------Create nuova transazione
  async createTransazione(transazioneData) {
    try {
      const response = await fetch(`${API_BASE_URL}/transazioni`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(transazioneData)
      });
      if (!response.ok) throw new Error('Errore creazione transazione');
      return await response.json();
    } catch (error) {
      console.error('Errore creazione transazione:', error);
      throw error;
    }
  }

  // --------------===================================Update transazione
  async updateTransazione(id, transazioneData) {
    try {
      const response = await fetch(`${API_BASE_URL}/transazioni/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(transazioneData)
      });
      if (!response.ok) throw new Error('Errore aggiornamento transazione');
      return await response.json();
    } catch (error) {
      console.error('Errore aggiornamento transazione:', error);
      throw error;
    }
  }

  // =========================================--------Delete transazione
  async deleteTransazione(id) {
    try {
      const response = await fetch(`${API_BASE_URL}/transazioni/${id}`, {
        method: 'DELETE'
      });
      if (!response.ok) throw new Error('Errore eliminazione transazione');
    } catch (error) {
      console.error('Errore eliminazione transazione:', error);
      throw error;
    }
  }

  // ---=========================================Get singola transazione
  async getTransazione(id) {
    try {
      const response = await fetch(`${API_BASE_URL}/transazioni/${id}`);
      if (!response.ok) throw new Error('Errore caricamento transazione');
      return await response.json();
    } catch (error) {
      console.error('Errore caricamento transazione:', error);
      throw error;
    }
  }
}

export default new TransazioniService();
